import project1 from '../src/assets/images/projects/project1.jpg'
import project2 from '../src/assets/images/projects/project2.jpg'
import project3 from '../src/assets/images/projects/project3.jpg'
import project4 from '../src/assets/images/projects/project4.jpg'
import project5 from '../src/assets/images/projects/project5.jpg'
import project6 from '../src/assets/images/projects/project6.jpg'

export const slides = [
    {
        src: project1,
        title: '',
        description: '',
    },

    {
        src: project2,
        title: '',
        description: '',
    },

    {
        src: project3,
        title: '',
        description: '',
    },

    {
        src: project4,
        title: '',
        description: '',
    },

    {
        src: project5,
        title: '',
        description: '',
    },

    {
        src: project6,
        title: '',
        description: '',
    },
]
